module.exports = __webpack_public_path__ + "img/liqpay.408aa1e6.png";